import { useMutation, useQueryClient } from '@tanstack/react-query';
import { SessionsAPI } from '@newo/api/gateway';
import type { TSessionsData } from '@newo/api/gateway';
import axios from '@/utils/api/axiosInstance';

const sessionsAPI = new SessionsAPI(axios);
const WAITING_SERVER_UPDATE = 1000;
export const useSessionUpdate = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: async ({
            sessionId,
            data
        }: {
            sessionId: string;
            data: TSessionsData;
        }) => sessionsAPI.updateSession(sessionId, data),
        onSuccess: () => {
            setTimeout(() => {
                queryClient.invalidateQueries({ queryKey: ['bff/sessions'] });
            }, WAITING_SERVER_UPDATE);
        }
    });
};
